export default __webpack_public_path__ + "static/media/EM1230.34I-31135_-17704_0.522e01f1.jpg";